import React from "react"
import './NoDataFound.css'
import { handleDataProcessing } from "../../../../../../commonservices/CommonMethods"

const NoDataFound = (props) => {

    return (
        <div className="no-data-found-wrapper">
            <div className="no-data-found">
                <p>{props.message ? props.message : props?.customMessage ? handleDataProcessing(props?.loader,props?.dataLoaded):'No Records Found'}</p>
            </div>
        </div>
    )
}

export default NoDataFound